import { typeof as _typeof, defineProperty as _defineProperty, asyncToGenerator as _asyncToGenerator, extends as _extends, objectSpread2 as _objectSpread2, regenerator as _regenerator } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { i18n } from '../../../i18n/translate.js';
import { getData } from '../../../json-api/JsonApiUtils.js';
import lodashSortBy from 'lodash/sortBy.js';
import { getPageSize } from '../../../utils/pageSize.js';
import { ScrollElementToTarget } from '../../../utils/WindowHelper.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from '../Controls/FormControl.js';
import { Button } from '../../Button/index.js';
import { Chip } from '../../Chip/index.js';
import { FAIcon } from '../../fa-icon/component.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';
var autoComplete = function autoComplete(props) {
  return props.autocomplete && props.autocomplete === 'off' ? {
    autoComplete: 'nope',
    autoCorrect: 'off',
    spellCheck: 'off'
  } : {};
};
var isValidRequiredValue = function isValidRequiredValue(props) {
  var value = props.value;
  if (value instanceof Array) {
    return value.length > 0;
  }
  return !!getDefaultOptionValue(value, props);
};
var checkSelectError = function checkSelectError() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var select = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof props.setError === 'function') {
    if (props.required && !isValidRequiredValue(select.props)) {
      props.setError(true, i18n.t('This field is required'));
    } else {
      props.setError(false);
    }
  }
};
var checkError = function checkError(props, select) {
  if (typeof props.setError === 'function') {
    var _select$wrapper;
    var input = select === null || select === void 0 || (_select$wrapper = select.wrapper) === null || _select$wrapper === void 0 ? void 0 : _select$wrapper.querySelector('input');
    if (props.required && (!input || !input.value)) {
      props.setError(true, i18n.t('This field is required'));
    } else {
      props.setError(false);
    }
  }
};
var getDefaultOptionLabel = function getDefaultOptionLabel() {
  var _ref, _ref2, _ref3, _ref4, _option$labelKey, _option$attributes, _option$attributes2;
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var displayProperty = props.displayProperty,
    labelKey = props.labelKey;
  return (_ref = (_ref2 = (_ref3 = (_ref4 = (_option$labelKey = option === null || option === void 0 ? void 0 : option[labelKey]) !== null && _option$labelKey !== void 0 ? _option$labelKey : option === null || option === void 0 || (_option$attributes = option.attributes) === null || _option$attributes === void 0 ? void 0 : _option$attributes[labelKey]) !== null && _ref4 !== void 0 ? _ref4 : option === null || option === void 0 ? void 0 : option[displayProperty]) !== null && _ref3 !== void 0 ? _ref3 : option === null || option === void 0 || (_option$attributes2 = option.attributes) === null || _option$attributes2 === void 0 ? void 0 : _option$attributes2[displayProperty]) !== null && _ref2 !== void 0 ? _ref2 : option === null || option === void 0 ? void 0 : option.display) !== null && _ref !== void 0 ? _ref : option === null || option === void 0 ? void 0 : option.label;
};
var getDefaultOptionValue = function getDefaultOptionValue() {
  var _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _option$valueKey, _option$attributes3, _option$data, _option$attributes4, _option$data2;
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var valueKey = props.valueKey,
    valueProperty = props.valueProperty;
  return (_ref5 = (_ref6 = (_ref7 = (_ref8 = (_ref9 = (_ref0 = (_option$valueKey = option === null || option === void 0 ? void 0 : option[valueKey]) !== null && _option$valueKey !== void 0 ? _option$valueKey : option === null || option === void 0 || (_option$attributes3 = option.attributes) === null || _option$attributes3 === void 0 ? void 0 : _option$attributes3[valueKey]) !== null && _ref0 !== void 0 ? _ref0 : option === null || option === void 0 || (_option$data = option.data) === null || _option$data === void 0 ? void 0 : _option$data[valueKey]) !== null && _ref9 !== void 0 ? _ref9 : option === null || option === void 0 ? void 0 : option[valueProperty]) !== null && _ref8 !== void 0 ? _ref8 : option === null || option === void 0 || (_option$attributes4 = option.attributes) === null || _option$attributes4 === void 0 ? void 0 : _option$attributes4[valueProperty]) !== null && _ref7 !== void 0 ? _ref7 : option === null || option === void 0 || (_option$data2 = option.data) === null || _option$data2 === void 0 ? void 0 : _option$data2[valueProperty]) !== null && _ref6 !== void 0 ? _ref6 : option === null || option === void 0 ? void 0 : option.value) !== null && _ref5 !== void 0 ? _ref5 : option === null || option === void 0 ? void 0 : option.id;
};
var getValueObject = function getValueObject(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var creatable = props.creatable,
    displayProperty = props.displayProperty,
    labelKey = props.labelKey,
    valueKey = props.valueKey,
    valueProperty = props.valueProperty;
  if (_typeof(value) !== 'object') {
    var _options$filter;
    var filteredOptions = options === null || options === void 0 || (_options$filter = options.filter) === null || _options$filter === void 0 ? void 0 : _options$filter.call(options, function (option) {
      var _option$displayProper, _option$attributes5, _option$labelKey2, _option$attributes6, _option$valueKey2, _option$attributes7, _option$valueProperty, _option$attributes8, _Object$values, _Object$values$includ;
      var optionDisplayProperty = (_option$displayProper = option === null || option === void 0 ? void 0 : option[displayProperty]) !== null && _option$displayProper !== void 0 ? _option$displayProper : option === null || option === void 0 || (_option$attributes5 = option.attributes) === null || _option$attributes5 === void 0 ? void 0 : _option$attributes5[displayProperty];
      var optionLabelKey = (_option$labelKey2 = option === null || option === void 0 ? void 0 : option[labelKey]) !== null && _option$labelKey2 !== void 0 ? _option$labelKey2 : option === null || option === void 0 || (_option$attributes6 = option.attributes) === null || _option$attributes6 === void 0 ? void 0 : _option$attributes6[labelKey];
      var optionValueKey = (_option$valueKey2 = option === null || option === void 0 ? void 0 : option[valueKey]) !== null && _option$valueKey2 !== void 0 ? _option$valueKey2 : option === null || option === void 0 || (_option$attributes7 = option.attributes) === null || _option$attributes7 === void 0 ? void 0 : _option$attributes7[valueKey];
      var optionValueProperty = (_option$valueProperty = option === null || option === void 0 ? void 0 : option[valueProperty]) !== null && _option$valueProperty !== void 0 ? _option$valueProperty : option === null || option === void 0 || (_option$attributes8 = option.attributes) === null || _option$attributes8 === void 0 ? void 0 : _option$attributes8[valueProperty];
      return (_Object$values = Object.values(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, (option === null || option === void 0 ? void 0 : option.display) && {
        display: option.display
      }), (option === null || option === void 0 ? void 0 : option.id) && {
        id: option.id
      }), (option === null || option === void 0 ? void 0 : option.label) && {
        label: option.label
      }), (option === null || option === void 0 ? void 0 : option.value) && {
        value: option.value
      }), optionDisplayProperty && _defineProperty({}, displayProperty, optionDisplayProperty)), optionLabelKey && _defineProperty({}, labelKey, optionLabelKey)), optionValueKey && _defineProperty({}, valueKey, optionValueKey)), optionValueProperty && _defineProperty({}, valueProperty, optionValueProperty)))) === null || _Object$values === void 0 || (_Object$values$includ = _Object$values.includes) === null || _Object$values$includ === void 0 ? void 0 : _Object$values$includ.call(_Object$values, String(value));
    });
    if ((filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) > 0) {
      return filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions[0];
    }
    if (creatable) {
      return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, displayProperty && _defineProperty({}, displayProperty, value)), labelKey && _defineProperty({}, labelKey, value)), valueKey && _defineProperty({}, valueKey, value)), valueProperty && _defineProperty({}, valueProperty, value)), {}, {
        disabled: false,
        display: value,
        id: value,
        label: value,
        value: value
      });
    }
  }
  return value;
};
var getFormattedValue = function getFormattedValue(value) {
  var _value$map$filter, _value$map, _value$map$filter2;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var multi = props.multi,
    isMulti = props.isMulti;
  if (!multi && !isMulti) {
    return getValueObject(value, options, props);
  }
  return (_value$map$filter = value === null || value === void 0 || (_value$map = value.map) === null || _value$map === void 0 || (_value$map = _value$map.call(value, function (val) {
    return getValueObject(val, options, props);
  })) === null || _value$map === void 0 || (_value$map$filter2 = _value$map.filter) === null || _value$map$filter2 === void 0 ? void 0 : _value$map$filter2.call(_value$map, function (val) {
    return _typeof(val) === 'object';
  })) !== null && _value$map$filter !== void 0 ? _value$map$filter : [];
};
var getSelectData = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee(input, props, clientSideFilter) {
    var authToken, buildDisplay, dataUrl, disabledOptionsIds, displayProperty, labelKey, onDataReady, optionsToAppend, optionsToPrepend, pageSize, queryFields, sortBy, valueKey, valueProperty, queryParams, _yield$getData, data, options, _options$filter2, _options, _options$filter3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          authToken = props.authToken, buildDisplay = props.buildDisplay, dataUrl = props.dataUrl, disabledOptionsIds = props.disabledOptionsIds, displayProperty = props.displayProperty, labelKey = props.labelKey, onDataReady = props.onDataReady, optionsToAppend = props.optionsToAppend, optionsToPrepend = props.optionsToPrepend, pageSize = props.pageSize, queryFields = props.queryFields, sortBy = props.sortBy, valueKey = props.valueKey, valueProperty = props.valueProperty;
          if (queryFields && input) {
            queryParams = {
              name: {
                term: input,
                fields: queryFields
              }
            };
          }
          _context.n = 1;
          return getData(dataUrl, {
            authToken: authToken,
            filters: _objectSpread2(_objectSpread2({}, props.filters), props.filterField && input && !queryFields ? _defineProperty({}, props.filterField, input) : undefined),
            sorts: sortBy && [{
              value: sortBy,
              direction: 'asc'
            }],
            page: {
              number: 1,
              size: pageSize || getPageSize()
            },
            query: queryParams
          });
        case 1:
          _yield$getData = _context.v;
          data = _yield$getData.data;
          options = data.map(function (i) {
            var _disabledOptionsIds$i, _i, _i$attributes, _i$labelKey, _i$attributes2, _i2, _i$attributes3, _i$displayProperty, _i$attributes4, _i$displayProperty2, _i$attributes5;
            var buildDisplayVal = buildDisplay && buildDisplay(i);
            var disabled = !!disabledOptionsIds.length && (disabledOptionsIds === null || disabledOptionsIds === void 0 || (_disabledOptionsIds$i = disabledOptionsIds.includes) === null || _disabledOptionsIds$i === void 0 ? void 0 : _disabledOptionsIds$i.call(disabledOptionsIds, i.id));
            var valueKeyObj = valueKey || valueProperty && _defineProperty({}, valueKey !== null && valueKey !== void 0 ? valueKey : valueProperty, (_i = i === null || i === void 0 ? void 0 : i[valueKey !== null && valueKey !== void 0 ? valueKey : valueProperty]) !== null && _i !== void 0 ? _i : i === null || i === void 0 || (_i$attributes = i.attributes) === null || _i$attributes === void 0 ? void 0 : _i$attributes[valueKey !== null && valueKey !== void 0 ? valueKey : valueProperty]);
            var labelKeyObj = labelKey && _defineProperty({}, labelKey, (_i$labelKey = i === null || i === void 0 ? void 0 : i[labelKey]) !== null && _i$labelKey !== void 0 ? _i$labelKey : i === null || i === void 0 || (_i$attributes2 = i.attributes) === null || _i$attributes2 === void 0 ? void 0 : _i$attributes2[labelKey]);
            // label is derived from value
            var valueLabelKeyObj = !labelKey && !displayProperty && (valueKey || valueProperty) && {
              label: (_i2 = i === null || i === void 0 ? void 0 : i[valueKey !== null && valueKey !== void 0 ? valueKey : valueProperty]) !== null && _i2 !== void 0 ? _i2 : i === null || i === void 0 || (_i$attributes3 = i.attributes) === null || _i$attributes3 === void 0 ? void 0 : _i$attributes3[valueKey !== null && valueKey !== void 0 ? valueKey : valueProperty]
            };
            var displayPropertyObj = displayProperty && _defineProperty({}, labelKey || 'label', (_i$displayProperty = i === null || i === void 0 ? void 0 : i[displayProperty]) !== null && _i$displayProperty !== void 0 ? _i$displayProperty : i === null || i === void 0 || (_i$attributes4 = i.attributes) === null || _i$attributes4 === void 0 ? void 0 : _i$attributes4[displayProperty]);
            // value is derived from displayProperty
            var valueDisplayPropertyObj = displayProperty && !valueProperty && !valueKey && {
              value: (_i$displayProperty2 = i === null || i === void 0 ? void 0 : i[displayProperty]) !== null && _i$displayProperty2 !== void 0 ? _i$displayProperty2 : i === null || i === void 0 || (_i$attributes5 = i.attributes) === null || _i$attributes5 === void 0 ? void 0 : _i$attributes5[displayProperty]
            };
            return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, valueKeyObj), labelKeyObj), valueLabelKeyObj), {}, {
              data: i,
              disabled: disabled,
              display: buildDisplayVal || "".concat(i[displayProperty])
            }, displayPropertyObj), valueDisplayPropertyObj);
          });
          options = lodashSortBy(options, function (option) {
            var _option$display, _option$display$toLow;
            return (_option$display = option.display) === null || _option$display === void 0 || (_option$display$toLow = _option$display.toLowerCase) === null || _option$display$toLow === void 0 ? void 0 : _option$display$toLow.call(_option$display);
          }); // Temporary sorting until we get sorted results from api

          /*
            postGetOptions. Similar to buildDisplay except
            used for taking ALL options, making changes, then sending
            them all back in as one object.
          */
          if (!props.postGetOptions) {
            _context.n = 3;
            break;
          }
          _context.n = 2;
          return props.postGetOptions(options);
        case 2:
          options = _context.v;
        case 3:
          if (optionsToPrepend) options = optionsToPrepend.concat(options);
          if (optionsToAppend) options = optionsToAppend.concat(options);
          if (onDataReady) onDataReady(options);

          // filter for async search
          if (clientSideFilter && input) {
            options = (_options$filter2 = (_options = options) === null || _options === void 0 || (_options$filter3 = _options.filter) === null || _options$filter3 === void 0 ? void 0 : _options$filter3.call(_options, function (option) {
              var _String$toLowerCase, _String$toLowerCase$i;
              return (_String$toLowerCase = String(option === null || option === void 0 ? void 0 : option.display).toLowerCase()) === null || _String$toLowerCase === void 0 || (_String$toLowerCase$i = _String$toLowerCase.includes) === null || _String$toLowerCase$i === void 0 ? void 0 : _String$toLowerCase$i.call(_String$toLowerCase, String(input).toLowerCase());
            })) !== null && _options$filter2 !== void 0 ? _options$filter2 : [];
          }
          return _context.a(2, options !== null && options !== void 0 ? options : []);
      }
    }, _callee);
  }));
  return function getSelectData(_x, _x2, _x3) {
    return _ref17.apply(this, arguments);
  };
}();
var selectOnChange = function selectOnChange(value, props, select, skipValueChange) {
  var _select$props;
  if (typeof props.onChange === 'function') {
    props.onChange(value);
  }
  if (typeof props.onValueChange === 'function' && !skipValueChange) {
    var changedValue = null;
    if (!value) return;
    if (value instanceof Array) {
      changedValue = value.map(function (val) {
        return getDefaultOptionValue(val, props);
      });
    } else {
      changedValue = getDefaultOptionValue(value, props);
    }
    props.onValueChange(_defineProperty({}, props.name, changedValue));
  }
  if (typeof (select === null || select === void 0 || (_select$props = select.props) === null || _select$props === void 0 ? void 0 : _select$props.loadOptions) === 'function' && !value && select && props.dataUrl) {
    select.props.loadOptions(null);
  }
  return value;
};
var onFocus = function onFocus(e, props) {
  var el = !props.scrollContainerId ? window : document.getElementById(props.scrollContainerId);
  var target = e.target;
  ScrollElementToTarget(el, target, 200);
  if (typeof props.onFocus === 'function') {
    props.onFocus(e);
  }
};
var translationProps = {
  searchPromptText: i18n.t('Type to search'),
  noResultsText: i18n.t('No results found'),
  loadingPlaceholder: i18n.t('Loading...'),
  clearAllText: i18n.t('Clear all'),
  clearValueText: i18n.t('Clear value')
};
var defaultMultiselectProps = Object.assign({}, FormControl.defaultProps, {
  creatable: false,
  disabledOptionsIds: [],
  filters: {},
  placeholderText: '',
  requireInput: false,
  valueChangeDelay: 500,
  valueProperty: 'id',
  isLegacyOverride: true,
  clientSideFilter: false
});
var rendererProps = function rendererProps(multi) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var dataAttributeProps = props && pickDataAttributes(props);
  var SingleValueComponent = function SingleValueComponent(val) {
    var children = val.children,
      id = val.id;
    return /*#__PURE__*/React.createElement("div", _extends({
      className: "Select-value"
    }, dataAttributeProps), /*#__PURE__*/React.createElement("span", {
      "aria-selected": "true",
      className: "Select-value-label",
      id: id,
      role: "option"
    }, children));
  };
  var MultiValueComponent = function MultiValueComponent(val) {
    var children = val.children,
      disabled = val.disabled,
      onClick = val.onClick,
      onRemove = val.onRemove,
      value = val.value;
    var performOnClick = function performOnClick() {
      if (onClick) {
        onClick(value);
      }
    };
    var performOnRemove = function performOnRemove() {
      onRemove(value);
    };
    return /*#__PURE__*/React.createElement(Chip, {
      value: React.Children.toArray(children)[0],
      disabled: disabled,
      onClick: performOnClick,
      onRemove: performOnRemove
    });
  };
  return {
    arrowRenderer: function arrowRenderer() {
      return /*#__PURE__*/React.createElement(FAIcon, {
        icon: "angle-down"
      });
    },
    clearRenderer: function clearRenderer() {
      return /*#__PURE__*/React.createElement(Button, {
        style: "link",
        icon: "xmark"
      });
    },
    valueComponent: multi ? MultiValueComponent : SingleValueComponent
  };
};
var multiSelectPropTypes = {
  authToken: PropTypes.string,
  buildDisplay: PropTypes.func,
  cacheEnabled: PropTypes.bool,
  children: PropTypes.any,
  clientSideFilter: PropTypes.bool,
  creatable: PropTypes.bool,
  dataUrl: PropTypes.string.isRequired,
  dataValue: PropTypes.any,
  disabled: PropTypes.bool,
  disabledOptionsIds: PropTypes.array,
  displayProperty: PropTypes.string,
  draggable: PropTypes.bool,
  filterField: PropTypes.string.isRequired,
  filters: PropTypes.object,
  initialData: PropTypes.any,
  onChange: PropTypes.func,
  onDataReady: PropTypes.func,
  optionsToAppend: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    display: PropTypes.string
  })),
  optionsToPrepend: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    display: PropTypes.string
  })),
  pageSize: PropTypes.number,
  postGetOptions: PropTypes.func,
  queryFields: PropTypes.object,
  requireInput: PropTypes.bool,
  scrollContainerId: PropTypes.string,
  sortBy: PropTypes.string,
  valueChangeDelay: PropTypes.number,
  valueProperty: PropTypes.string,
  isLegacyOverride: PropTypes.bool
};
export { autoComplete, checkError, checkSelectError, defaultMultiselectProps, getDefaultOptionLabel, getDefaultOptionValue, getFormattedValue, getSelectData, multiSelectPropTypes, onFocus, rendererProps, selectOnChange, translationProps };